export const PAYMENT_PROCESSORS = {
  stripe: "stripe",
};
